module.exports = __webpack_public_path__ + "img/4-9-alumni.3d3a7e12.jpg";